import React, { useState, useEffect, useContext } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { assignmentPopupData} from '../../../common/apiService';
import { UserContext } from '../../../contexts/UserContext';
import { isNumberWithoutDecimal } from '../../../service/utilService'
import { toast } from 'react-toastify'
import { FaSpinner } from 'react-icons/fa';

export default function Selfassignpopupscreenui({ origin, show1, setShow1, activeCount, updateActiveCount, setGlobalAssignedToMe, globalassignedtome, assignBy, jsonD, griddata = ()=>{} }) {
    const userDetail = useContext(UserContext);
    const [assignto, setAssignto] = useState("me");
    const [assigncount, setAssigncount] = useState("");
    const [assign, setAssign] = useState(false);
    const [nonFlexBtn, setNonFlexBtn] = useState(false);
    const [flexBtn, setFlexBtn] = useState(true);
    const [loading, setLoading] = useState(false);


    const setAssignCountValue = (val) => {
        if (isNumberWithoutDecimal(val))
            setAssigncount(val);
    }

    const handleChange = e => {
        const { value } = e.target;
        setAssignto(value);
        setAssigncount('');
        if (value === 'me') {
            setAssign(false);
            setNonFlexBtn(false);
            setFlexBtn(true);
        } else {
            setAssign(true);
            setNonFlexBtn(true);
            setFlexBtn(false);
        }
    };

    const assignViolation = async () => {
        setLoading(true);

        if (Number(assigncount) > Number(activeCount)) {
            toast.warning("Violation count should not be greater-than Total Active Violations!");
            return;
        } 

        /* const headerjson = {
            plazaIds: jsonD?.plazaIds || userDetail.plaza,
            ViolationStatus : assignBy || '""',
            startDate : jsonD?.startDate,
            endDate : jsonD?.endDate, 
            dateType : jsonD?.dateType || jsonD?.DateType,
            cases: assigncount
        }
        const bodyjson = {
            cases: assigncount
        } */
        const headerjson = {
            ViolationStatus : assignBy || '""',
            startDate : jsonD?.startDate,
            endDate : jsonD?.endDate,
            dateType : jsonD?.dateType || jsonD?.DateType
        }
        const bodyjson = {
            cases: Number(assigncount) || 0,
            plazaIds: Array.isArray(jsonD?.plazaIds) ? jsonD?.plazaIds.join(",") : jsonD?.plazaIds || (Array.isArray(userDetail.plaza) ? userDetail.plaza.join(",") : userDetail.plaza)
        }
        await assignmentPopupData(headerjson, bodyjson);

        setAssigncount('');
        setShow1(false);
        setLoading(false);
        if (origin === "assign") {
            updateActiveCount(activeCount - assigncount);
            griddata();
        } else if (origin === "dashboardassign") {
            setGlobalAssignedToMe(globalassignedtome + +assigncount);
            updateActiveCount(activeCount - assigncount);
            griddata();
        }

    }

    useEffect(() => {
        setAssigncount("");
    }, [show1])

    return (

        <>
            < Modal show={show1} onHide={() => setShow1(false)} size="lg" className="assignedpopup" centered >
                <Modal.Body>
                    <div className="modalbody-left">
                        Violations assignment
                        <p><br /><input type="radio" name="assignradio" id="assignme"
                            checked={assignto === "me"} I
                            value="me"
                            onChange={handleChange} />&nbsp;
                            <label style={{ cursor: 'pointer' }} htmlFor="assignme" >  Assign to me</label>
                            &nbsp; &nbsp; &nbsp; &nbsp;
                            {/* <input type="radio" name="assignradio" id="assignother"
                                checked={assignto === "other"}
                                value="other"
                                onChange={handleChange} />&nbsp;
                            <label style={{ cursor: 'pointer' }} htmlFor="assignother" >   Assign to other</label> */}
                        </p>
                    </div>
                    <div className="modalbody-right">Total Active Violations<br />
                        <p>{activeCount}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{display: 'block'}}>
                    <div className="modal-flex-container">
                        <div className="modalfooter-center">Enter or select violation count
                            <div style={{ position: 'relative', width: '197px', marginTop: 5 }}>
                                <input type="text" placeholder="Enter or select count"
                                    style={{ boxShadow: 'none' }}
                                    className="form-control" id="countlov" autoComplete="off"
                                    value={assigncount} maxLength="5"
                                    onChange={(e) => setAssignCountValue(e.target.value)} />
                            </div>
                            <br />
                            <br />
                        </div>
                        {flexBtn && <div className="modelfooter-right" id="flex-btn">
                            <Button variant="secondary" onClick={() => setShow1(false)}>
                                CANCEL
                            </Button> &nbsp; &nbsp;
                            <Button variant="primary" disabled={assigncount > 0 ? false : true} style={{ backgroundColor: '#303A78', border: 'none', position:'relative' }} onClick={assignViolation}>
                                ASSIGN  {loading &&   <FaSpinner icon="spinner" spin className = "spinner"/> }
                            </Button>
                        </div>
                        }
                    </div>
                    {nonFlexBtn && <div className="modelfooter-right" id="non-flex-btn">
                        <Button variant="secondary" onClick={() => setShow1(false)}>
                            CANCEL
                        </Button> &nbsp; &nbsp;
                        <Button variant="primary" disabled={assigncount > 0 ? false : true} style={{ backgroundColor: '#303A78', border: 'none' }} onClick={assignViolation}>
                            ASSIGN  {loading &&   <FaSpinner icon="spinner" spin className = "spinner"/> }
                        </Button>
                    </div>
                    }
                </Modal.Footer>
            </Modal >
        </>
    )
}